// useToast.js
import React, { useState, useContext, createContext } from 'react';
import Toast from './Toast';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState(null);

  const showToast = (message) => {
    setToast(message);
  };

  const closeToast = () => {
    setToast(null);
  };

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      {toast && <Toast message={toast} onClose={closeToast} />}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  return useContext(ToastContext);
};
